/* eslint-disable camelcase */
import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import moment from 'moment-timezone'

import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { AppConfig } from '../../../AppConfig';
import { Helper } from '../../../common/helpers/Helper';
import { Controller } from '../../../common/Controller';
import { CRMHelper } from '../../../helpers/CRMHelper';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { StatCard } from '../../../common/components/StatCard';
import { Grid } from '@material-ui/core';
import { AppTheme } from '../../../styles/AppTheme';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { AppHelper } from '../../../helpers/AppHelper';

function parseCdpSettings(str) {
  if (!str || typeof str !== 'string') return [];

  return str.split('|').map(group => group.trim()).filter(Boolean)
    .map(group => {
      const obj = {};
      group
        .split(';')
        .map(part => part.trim())
        .filter(Boolean)
        .forEach(pair => {
          const [rawKey, ...rawValue] = pair.split(':');
          if (!rawKey || !rawValue.length) return;

          const key = rawKey.trim();
          const value = rawValue.join(':').trim();

          obj[key] = value;
        });

      return obj;
    });
}

function getCountOfDaysInCustomDateRange(date, timezone) {
  let countOfDays = 0
  const tz = timezone || Helper.getLocalTimezone()

  if (date && date.startValue && date.endValue) {
    const start = moment.tz(date.startValue, tz).startOf('day')
    const end = moment.tz(date.endValue, tz).startOf('day')
    countOfDays = end.diff(start, 'days') + 1
  }

  return countOfDays
}


export class CrmOneview extends BaseEntityPageSlixta {

  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.subOrgId = Controller.get().userMgr().getSubOrgId(this.orgId)
    this.staffUserId = Controller.get().getUserId()
    this.currentUser = `${this.orgId}-${this.staffUserId}`
    this.pageTitle = Helper.getString('Oneview')
    this.pageKey = 'oneview'
    this.dateMap = {
      today: '1h',
      yesterday: '1h',
      this_week: '1d',
      this_month: '1d',
      last_7d: '1d',
      last_30d: '1d',
      last_90d: '1d',
      last_6m: '1M',
      last_12m: '1M',
      current_7d: '1d',
      current_30d: '1d',
      current_90d: '1d',
      current_6m: '1M',
      current_12m: '1M',
      next_7d: '1d',
    }
    this.defaultDateInteval = {id: 'last_30d'}
    this.aggregationTermsLimit = 100
    this.toFetch = [
      { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId}), pb: 'fieldDef', includeCustomFields: 'true', limit: 100, 'tags!': 'INTERNAL', _datetimezone: Helper.getLocalTimezone(), _dateinterval: this.dateMap[this.defaultDateInteval.id], _aggTermsLimit: this.aggregationTermsLimit } },
    ]
    this.noAdd = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]
    this.isMobileView = Helper.isMobileView()
    this.apiData = {
      orgId: this.orgId,
    }
    this.isHeaderActionsHidden = this.isMobileView ? true : false
    this.state.crmStatsGroups = []
  }

  getResult(results, key) {
    const index = this.toFetch.findIndex(i => i.key === key)
    return (index >= 0 && index < results.length) ? results[index] : null
  }

  fetchItems() {
    this.apiStartTs = Helper.currentTs()
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      isOrderChanged: false,
      customError: null
    })
    const fcns = [];
    for (const f of this.toFetch) {
      fcns.push(function (callback) {
        ApiHelper.call(f, callback);
      })
    }
    async.parallel(fcns, async function (err, results) {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }
      if (this.onFetchSuccess) {
        if (this.toFetch.length > 0) {
          Helper.amplifyEvent({
            name: 'apiLoad',
            attributes: { path: this.props.match.path, orgId: this.orgId },
            metrics: { apiTimeMs: Helper.currentTs() - this.apiStartTs }
          })
        }
        await this.onFetchSuccess(results);
      }
    }.bind(this))
  }

  getDateInterval(searchFilters, timezone) {
    let dateInterval = this.dateMap[this.defaultDateInteval.id]
    if(searchFilters && searchFilters.createdTs && searchFilters.createdTs.id) {
      if(searchFilters.createdTs.id === 'custom') {
        const countOfDays = getCountOfDaysInCustomDateRange(searchFilters.createdTs, timezone)
        if (countOfDays === 1) {
          dateInterval = '1h'
        } else if (countOfDays > 90) {
          dateInterval = '1M'
        }
        else{
          dateInterval = '1d'
        }
      } else {
        dateInterval = this.dateMap[searchFilters.createdTs.id]
      }
    }
    return dateInterval
  }

  onFetchSuccess(results) {
    this.crmContactsResult = this.getResult(results, 'crmcontacts')
    this.fieldDef = this.formDefinition = this.crmContactsResult.fieldDef
    const crmStatsGroupsCdpSettings = AppHelper.getSetting(this.orgId, 'CRM_ONEVIEW_GROUPS')
    const crmStatsGroupsData = parseCdpSettings(crmStatsGroupsCdpSettings)
    if(crmStatsGroupsData && crmStatsGroupsData.length > 0) {
      const filterFormDefConf = {
        fields: {
          assignee: {
            optionsValueMapping: {
              'current-user': this.currentUser || ''
            }
          }
        }
      }

      this.setState({
        fetchState: ApiHelper.State.LOADING
      })

      const requestPromises = []
      const groupData = []
      crmStatsGroupsData.forEach((group)=>{
        if(group && group.filter && this.fieldDef) {
          const currentUrl = `https://filter.slixta.com?${group.filter}`
          const { filterOptions, searchText, searchFilters, showInternal } = CRMHelper.getFilterOptions(this.fieldDef, filterFormDefConf, currentUrl)
          const searchFiltersQuery = CRMHelper.constructSearchFiltersQuery(searchFilters, filterOptions, showInternal)
          const formattedSearchText = searchText.trim().replace(/^\+(\d+)/, '$1').replace(/:/g, '\\:')
          const queryParams = { orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId}), query: formattedSearchText, pb: 'fieldDef', includeCustomFields: 'true', limit: 100, _datetimezone: Helper.getLocalTimezone(), _dateinterval: this.getDateInterval(searchFilters, this.state.timezone), _aggTermsLimit: this.aggregationTermsLimit, ...searchFiltersQuery }
          const options = { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams }
          requestPromises.push(ApiHelper.callAwait(options))
          groupData.push(group)
        }
      })

      const crmStatsGroups = []
      Promise.all(requestPromises).then((results) => {
        if(results && results.length > 0) {
          results.forEach((result, index)=>{
            crmStatsGroups.push({
              ...groupData[index],
              cards: result.cards.map(c => ({...c, key: c.key || c.label.toLowerCase()})),
            })
          })
          this.setState({
            crmStatsGroups: crmStatsGroups,
            fetchState: ApiHelper.State.READY
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }

  renderAboveTable() {
    const crmStatsGroups = this.state.crmStatsGroups
    if(crmStatsGroups && crmStatsGroups.length === 0) {
      const errorDetails = {
        message: Helper.getString('dataNotAvailable')
      }
      return(
        <div className={css(Styles.aboveTableContainer)}>
          {UiHelper.customErrorViewWithRefresh(errorDetails)}
        </div>
      )
    }

    return (
      <div className={css(Styles.aboveTableContainer)}>
        {crmStatsGroups.map((crmStatsGroup, index)=>{
          const cardsData = []
          const cardsFirstRow = []
          if (crmStatsGroup && Array.isArray(crmStatsGroup.cards) && crmStatsGroup.cards.length > 0) {
            crmStatsGroup.cards.forEach((card, i) => {
              cardsFirstRow.push({
                key: card.key,
                text: (card.key && card.key.startsWith('ltv')) ? Helper.formatLargeNumber(card.ltv || 0) : card.doc_count || 0,
                subText: card.label,
                cardIndex: i + 1,
                cardId: card.key,
                padding: 'small'
              })
            })
          }
          cardsData.push(cardsFirstRow)

          if(cardsData && cardsData.length > 0) {
            return (<div className={css(Styles.numericStatItemRow)}>
              {crmStatsGroup.label &&  <p className={css(Styles.paragraphMargin)}>{crmStatsGroup.label}</p>}
              {cardsData.map((row, index) => {
                const rowGroups = Array.from({ length: Math.ceil(row.length / 3) })
                return (
                  <Grid key={index}>
                    {rowGroups.map((_, groupIndex) => {
                      const groupItems = row.slice(groupIndex * 3, groupIndex * 3 + 3)
                      return (
                        <Grid
                          key={groupIndex}
                          container
                          className={css(Styles.numericStatContainerRow)}
                        >
                          {groupItems.map((card) => (
                            <StatCard
                              xs={12 / groupItems.length}
                              sm={12 / groupItems.length}
                              key={card.key}
                              text={card.text}
                              subText={card.subText}
                              cardIndex={card.cardIndex}
                              padding={card.padding}
                              cardId={card.cardId}
                              containerStyle={Styles.statsCardContainer}
                              cardStyle={Styles.statsCard}
                            />
                          ))}
                        </Grid>
                      )
                    })}
                  </Grid>
                )
              })}
            </div>)
          }

        })}
      </div>)

  }
}

const Styles = StyleSheet.create({
  aboveTableContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  numericStatItemRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    width: '100%',
    '@media (max-width: 1024px)': {
      width: '98%',
      alignSelf: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      height: '100%',
    },
  },
  numericStatContainerRow: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2px 0px 8px 0px',
    margin: 0,
    gap: 5,
    //justifyContent: 'left',
    '@media (max-width: 1024px)': {
      padding: '2px 0px',
      gap: 0
    },
  },
  statsCardContainer: {
    maxWidth: 'unset',
    flex: 1,
  },
  statsCard: {
    width: '100%'
  },
  paragraphMargin: {
    margin: 0,
    flex: 1,
    fontSize: 25,
    fontWeight: 500,
    '@media(max-width: 767px)': {
      fontSize: 20
    }
  },
})